export default __webpack_public_path__ + "static/media/video_best_case.742ab780.mp4";